module.exports = "https://static.zego.com/_next/static/images/_curveMask-9df5342f04cd56d4fdf1c2c5951db8c4.svg";